import { datadogRum } from '@datadog/browser-rum';
import { reactPlugin } from '@datadog/browser-rum-react';

datadogRum.init({
    applicationId: '19c1c9ca-24aa-4332-9129-7b8edcf5efb1',
    clientToken: 'pub060c16c5cebec24863b47ee93fefdde7',
    site: 'datadoghq.com',
    service: 'ePonto',
    env: process.env.NODE_ENV,
    version: '1.0.0',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackResources: true,
    trackUserInteractions: true,
    trackLongTasks: true,

    // ----- Recommended Options -----
    // allowedTracingUrls: '<BACKEND_URL>',        // Enable distributed tracing
    // defaultPrivacyLevel: 'mask-user-input',    // 'mask-user-input' | 'allow' | 'mask'
    plugins: [reactPlugin({ router: false })],
});
